import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { AppBadge, PLATFORMS } from '@paypalcorp/react-app-badges'
import content from 'pp-react-l10n'
import serverProps from '../../utils/serverProps'
import { connect } from 'transfer/utils/p2p-connect'

const i18n = content('transfer/badges')

export const LINKS = {
  [PLATFORMS.IOS]: 'https://apps.apple.com/app/id283646709',
  [PLATFORMS.ANDROID]:
    'https://play.google.com/store/apps/details?id=com.paypal.android.p2pmobile',
}

function Badge({ platform, onClick = () => {}, ...props }) {
  const locale = get(serverProps, 'locality.locale')
  const platformContent =
    platform === PLATFORMS.IOS
      ? i18n('badges.a11y.platform.ios')
      : i18n('badges.a11y.platform.android')

  return (
    <AppBadge
      platform={platform}
      url={LINKS[platform]}
      locale={locale}
      fontSize="1em" // controlled by the parent element
      onClick={() => onClick(platform)}
      anchorProps={{
        'aria-label': i18n('badges.a11y.anchorLabel', {
          platform: platformContent,
        }),
      }}
      imageProps={{
        alt: i18n('badges.a11y.imgAlt', {
          platform: platformContent,
        }),
      }}
    />
  )
}

Badge.propTypes = {
  platform: PropTypes.string,
  onClick: PropTypes.func,
}

function getBadges({ isiPhone, isAndroid, onClick }) {
  const ios = (
    <Badge key="iosBadge" platform={PLATFORMS.IOS} onClick={onClick} />
  )
  const android = (
    <Badge key="androidBadge" platform={PLATFORMS.ANDROID} onClick={onClick} />
  )

  if (isiPhone) {
    return ios
  }

  if (isAndroid) {
    return android
  }

  return [ios, android]
}

function Badges({ isiPhone, isAndroid, style = {}, onClick }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '0.8rem',
        fontSize: '3.5rem',
        ...style,
      }}
    >
      {getBadges({ isiPhone, isAndroid, onClick })}
    </div>
  )
}

Badges.propTypes = {
  isiPhone: PropTypes.bool,
  isAndroid: PropTypes.bool,
  style: PropTypes.object,
  onClick: PropTypes.func,
}

export default connect(({ server }) => ({
  isiPhone: server.isiPhone,
  isAndroid: server.isAndroid,
}))(Badges)
